import React, { useCallback, useEffect, useState, useRef, lazy } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const testimonials = [{
  name: 'Laura P.',
  location: 'Buenos Aires',
  role: 'Mamá de Mateo, 8 meses',
  avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=80&h=80&fit=crop&crop=face',
  quote: 'Pensé que estimular bien requería ser especialista. Con el Megapack entendí todo desde el primer tomo. Sé exactamente qué hacer cada semana y veo los resultados en Mateo. Está más atento, más activo y me busca más con la mirada.',
  time: '14:32',
  reply: 'Qué lindo leer eso 😊 Cuando tenés un sistema claro, la estimulación deja de ser una preocupación y se convierte en un momento de conexión real con tu hijo.'
}, {
  name: 'Marcela C.',
  location: 'Rosario',
  role: 'Mamá de Valentina, 18 meses',
  avatar: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=80&h=80&fit=crop&crop=face',
  quote: 'El semáforo de alertas del Tomo 3 me salvó. Vi que Valentina no estaba desarrollando el lenguaje como debía para su edad. Fui al pediatra a tiempo y pudimos actuar antes de que fuera tarde. Sin el Megapack no lo hubiera notado.',
  time: '09:15',
  reply: 'Eso es exactamente para lo que está diseñado el semáforo 🙌 Detectar a tiempo hace toda la diferencia. Qué bien que actuaste rápido.'
}, {
  name: 'Sofía V.',
  location: 'Córdoba',
  role: 'Mamá de Benjamín, 14 meses',
  avatar: 'https://images.unsplash.com/photo-1499952127939-9bbf5af6c51c?w=80&h=80&fit=crop&crop=face',
  quote: 'Antes improvisaba todo y me sentía culpable por no saber si lo estaba haciendo bien. Ahora tengo un sistema, tengo confianza y Benja lo nota. Está más estimulado, más curioso y los hitos los va cumpliendo uno a uno.',
  time: '18:47',
  reply: 'Me alegra mucho leer eso 😄 La culpa desaparece cuando tenés claridad. Y los chicos responden enseguida cuando la mamá está segura de lo que hace.'
}, {
  name: 'Florencia L.',
  location: 'Tucumán',
  role: 'Mamá de Emma, 10 meses',
  avatar: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=80&h=80&fit=crop&crop=face',
  quote: 'Las actividades del Tomo 2 son increíbles. Emma empezó a gatear una semana después de que empecé con los ejercicios de coordinación. Mi pediatra me preguntó qué estaba haciendo diferente. Le mostré el Megapack.',
  time: '11:03',
  reply: 'Qué hermoso momento ese 🥹 El gateo es un hito motor clave y las actividades de coordinación preparan todo el sistema neurológico para ese salto. Bien por Emma y bien por vos.'
}, {
  name: 'Ana R.',
  location: 'Mendoza',
  role: 'Mamá de Lucas y Sofía, mellizos de 24 meses',
  avatar: 'https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=80&h=80&fit=crop&crop=face',
  quote: 'Con mellizos pensé que era imposible tener un sistema. Pero los checklists y las actividades están tan bien organizadas que pude adaptarlas a los dos al mismo tiempo. En 3 meses vi avances que no esperaba ver hasta más adelante.',
  time: '20:21',
  reply: 'Con mellizos el sistema marca aún más la diferencia 😊 Tener todo organizado te libera la cabeza para estar presente. Qué logro el tuyo.'
}, {
  name: 'Valeria T.',
  location: 'Santa Fe',
  role: 'Mamá de Agustín, 30 meses',
  avatar: 'https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=80&h=80&fit=crop&crop=face',
  quote: 'El Tomo 5 llegó en el momento justo. Agustín estaba teniendo problemas para socializar y yo no sabía cómo acompañarlo. Los protocolos de juego compartido y las actividades cognitivas le cambiaron el humor. Es otro nene.',
  time: '16:58',
  reply: 'La etapa de los 24 a 30 meses es clave para la socialización 🌱 Qué bien que pudiste acompañarlo con herramientas concretas. Eso se nota para siempre.'
}, {
  name: 'Gabriela R.',
  location: 'Salta',
  role: 'Mamá de Renata, 6 meses',
  avatar: 'https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=80&h=80&fit=crop&crop=face',
  quote: 'Compré el Megapack cuando Renata tenía 3 meses. El Tomo 1 me enseñó cosas que el pediatra nunca me explicó. El masaje Shantala, los guiones para hablarle, el protocolo de des-estimulación. Ahora tengo una bebé tranquila y conectada.',
  time: '13:44',
  reply: 'Empezar desde los primeros meses es el mayor regalo que le podés dar 💚 Esa conexión que estás construyendo ahora es la base de todo lo que viene.'
}];
function WhatsAppChat({
  t
}: {
  t: (typeof testimonials)[0];
}) {
  return <div className="rounded-xl overflow-hidden shadow-lg w-full shrink-0" style={{
    backgroundColor: '#111b21'
  }} data-id="element-298">
      {/* Header */}
      <div className="flex items-center gap-3 px-4 py-3" style={{
      backgroundColor: '#1f2c34'
    }} data-id="element-299">
        <div className="relative" data-id="element-300">
          <img src={t.avatar} alt={t.name} width={40} height={40} loading="lazy" decoding="async" className="w-10 h-10 rounded-full object-cover" data-id="element-301" />
          <div className="absolute bottom-0 right-0 w-3 h-3 rounded-full border-2" style={{
          backgroundColor: '#22c55e',
          borderColor: '#1f2c34'
        }} data-id="element-302" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-303">
          <p className="font-semibold text-white m-0 text-sm truncate" data-id="element-304">
            {t.name}
          </p>
          <p className="m-0 text-xs" style={{
          color: '#8696a0'
        }} data-id="element-305">
            {t.role} · {t.location}
          </p>
        </div>
        <div style={{
        color: '#aebac1'
      }} data-id="element-306">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-307">
            <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" data-id="element-308" />
          </svg>
        </div>
      </div>

      {/* Chat area */}
      <div className="px-3 py-4 min-h-[160px] flex flex-col justify-end gap-2" style={{
      backgroundColor: '#0b141a',
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg width='200' height='200' xmlns='http://www.w3.org/2000/svg'%3E%3Cdefs%3E%3Cpattern id='p' width='40' height='40' patternUnits='userSpaceOnUse'%3E%3Ccircle cx='20' cy='20' r='1' fill='%23ffffff08'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='200' height='200' fill='url(%23p)'/%3E%3C/svg%3E\")"
    }} data-id="element-309">
        {/* Incoming bubble */}
        <div className="max-w-[92%] self-start relative" data-id="element-310">
          <div className="absolute -left-2 top-0 w-0 h-0" style={{
          borderTop: '8px solid #1f2c34',
          borderLeft: '8px solid transparent'
        }} data-id="element-311" />
          <div className="rounded-lg rounded-tl-none px-3 py-2" style={{
          backgroundColor: '#1f2c34'
        }} data-id="element-312">
            <p className="m-0 text-sm leading-relaxed" style={{
            color: '#e9edef'
          }} data-id="element-313">
              {t.quote}
            </p>
            <div className="flex items-center justify-end gap-1 mt-1" data-id="element-314">
              <span className="text-xs" style={{
              color: '#8696a0'
            }} data-id="element-315">
                {t.time}
              </span>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="none" data-id="element-316">
                <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.344.153.52.52 0 0 0 0 .688l2.357 2.547a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#53bdeb" data-id="element-317" />
                <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.712.737 1.557 1.683a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#53bdeb" data-id="element-318" />
              </svg>
            </div>
          </div>
        </div>

        {/* Reply bubble — púrpura */}
        <div className="max-w-[75%] self-end relative mt-1" data-id="element-319">
          <div className="absolute -right-2 top-0 w-0 h-0" style={{
          borderTop: '8px solid #7c3aed',
          borderRight: '8px solid transparent'
        }} data-id="element-320" />
          <div className="rounded-lg rounded-tr-none px-3 py-2" style={{
          backgroundColor: '#7c3aed'
        }} data-id="element-321">
            <p className="m-0 text-sm leading-relaxed" style={{
            color: '#f3e8ff'
          }} data-id="element-322">
              {t.reply}
            </p>
            <div className="flex items-center justify-end gap-1 mt-1" data-id="element-323">
              <span className="text-xs" style={{
              color: '#d8b4fe'
            }} data-id="element-324">
                {t.time}
              </span>
              <svg width="16" height="11" viewBox="0 0 16 11" fill="none" data-id="element-325">
                <path d="M11.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-2.011-2.175a.463.463 0 0 0-.336-.153.457.457 0 0 0-.344.153.52.52 0 0 0 0 .688l2.357 2.547a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#d8b4fe" data-id="element-326" />
                <path d="M15.071.653a.457.457 0 0 0-.304-.102.493.493 0 0 0-.381.178l-6.19 7.636-1.2-1.298-.712.737 1.557 1.683a.478.478 0 0 0 .336.178h.025a.46.46 0 0 0 .356-.178l6.537-8.063a.477.477 0 0 0-.046-.71z" fill="#d8b4fe" data-id="element-327" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      {/* Input bar */}
      <div className="flex items-center gap-2 px-3 py-2" style={{
      backgroundColor: '#1f2c34'
    }} data-id="element-328">
        <div style={{
        color: '#8696a0'
      }} data-id="element-329">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-330">
            <path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 18c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zm-4-9a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm5 0a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0zm-5.5 3.5c.828 1.5 2.5 2.5 4.5 2.5s3.672-1 4.5-2.5" data-id="element-331" />
          </svg>
        </div>
        <div className="flex-1 rounded-full px-4 py-2 text-sm" style={{
        backgroundColor: '#2a3942',
        color: '#8696a0'
      }} data-id="element-332">
          Escribe un mensaje
        </div>
        <div style={{
        color: '#8696a0'
      }} data-id="element-333">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" data-id="element-334">
            <path d="M12 15c1.66 0 3-1.34 3-3V6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5-3c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-2.08c3.39-.49 6-3.39 6-6.92h-2z" data-id="element-335" />
          </svg>
        </div>
      </div>
    </div>;
}
export function Testimonials() {
  const [current, setCurrent] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [slideDirection, setSlideDirection] = useState<'left' | 'right'>('left');
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const total = testimonials.length;
  const goTo = useCallback((index: number, dir: 'left' | 'right') => {
    if (isAnimating) return;
    setSlideDirection(dir);
    setIsAnimating(true);
    setTimeout(() => {
      setCurrent(index);
      setIsAnimating(false);
    }, 250);
  }, [isAnimating]);
  const next = useCallback(() => {
    goTo((current + 1) % total, 'left');
  }, [current, total, goTo]);
  const prev = useCallback(() => {
    goTo((current - 1 + total) % total, 'right');
  }, [current, total, goTo]);
  useEffect(() => {
    intervalRef.current = setInterval(() => next(), 10000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [next]);
  const touchStartX = useRef(0);
  const handleTouchStart = (e: React.TouchEvent) => {
    touchStartX.current = e.touches[0].clientX;
  };
  const handleTouchEnd = (e: React.TouchEvent) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) next();else prev();
    }
  };
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(243,232,255) 0%, rgb(253,244,255) 15%, rgb(253,244,255) 85%, rgb(243,232,255) 100%)'
  }} data-id="element-336">
      <div className="mx-auto max-w-2xl" data-id="element-337">
        {/* ── HEADING ── */}
        <h2 className="text-3xl font-black text-center text-gray-900 m-0 mb-2" data-id="element-338">
          Lo que dicen las madres{' '}
          <span style={{
          background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 50%, #ec4899 100%)',
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }} data-id="element-339">
            que ya lo usan:
          </span>
        </h2>
        <p className="text-center text-sm text-gray-500 m-0 mb-8" data-id="element-340">
          +2.400 madres de todo el país ya estimulan con un sistema real.
        </p>

        {/* ── CAROUSEL ── */}
        <div className="relative" onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} data-id="element-341">
          {/* Prev button */}
          <button onClick={prev} className="absolute left-0 top-1/2 -translate-y-1/2 sm:-translate-x-12 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110" style={{
          background: 'linear-gradient(135deg, #7c3aed 0%, #ec4899 100%)',
          color: '#fff'
        }} aria-label="Anterior testimonio" data-id="element-342">
            <ChevronLeftIcon size={20} data-id="element-343" />
          </button>

          {/* Next button */}
          <button onClick={next} className="absolute right-0 top-1/2 -translate-y-1/2 sm:translate-x-12 z-10 w-10 h-10 rounded-full flex items-center justify-center transition-all hover:scale-110" style={{
          background: 'linear-gradient(135deg, #7c3aed 0%, #ec4899 100%)',
          color: '#fff'
        }} aria-label="Siguiente testimonio" data-id="element-344">
            <ChevronRightIcon size={20} data-id="element-345" />
          </button>

          {/* Card */}
          <div className="overflow-hidden rounded-xl mx-10 sm:mx-0" data-id="element-346">
            <div style={{
            transition: isAnimating ? 'none' : 'opacity 0.25s ease, transform 0.25s ease',
            opacity: isAnimating ? 0 : 1,
            transform: isAnimating ? `translateX(${slideDirection === 'left' ? '-30px' : '30px'})` : 'translateX(0)'
          }} data-id="element-347">
              <WhatsAppChat t={testimonials[current]} data-id="element-348" />
            </div>
          </div>

          {/* Progress bar */}
          <div className="mt-4 mx-auto max-w-xs h-1 rounded-full overflow-hidden" style={{
          backgroundColor: 'rgb(226,232,240)'
        }} data-id="element-349">
            <div key={`progress-${current}`} className="h-full rounded-full" style={{
            background: 'linear-gradient(to right, #7c3aed, #ec4899)',
            width: '100%',
            transformOrigin: 'left',
            animation: 'progressFill 10s linear forwards'
          }} data-id="element-350" />
          </div>

          {/* Dots */}
          <div className="flex items-center justify-center gap-2 mt-4" data-id="element-351">
            {testimonials.map((_, i) => <button key={i} onClick={() => goTo(i, i > current ? 'left' : 'right')} className="transition-all duration-300 rounded-full" style={{
            width: i === current ? 24 : 8,
            height: 8,
            background: i === current ? 'linear-gradient(to right, #7c3aed, #ec4899)' : 'rgb(203,213,225)'
          }} aria-label={`Ir al testimonio ${i + 1}`} data-id="element-352" />)}
          </div>

          {/* Counter */}
          <p className="text-center mt-3 m-0 text-xs text-gray-400" data-id="element-353">
            {current + 1} / {total}
          </p>
        </div>
      </div>
    </section>;
}